var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuspendService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4bf06;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #df0006;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m44.2,1.8c-1.1-1.2-2.6-1.8-4.2-1.8h-19.9c-1.6,0-3.1.6-4.2,1.8L1.8,15.8c-1.1,1.1-1.8,2.7-1.8,4.2v19.9c0,1.6.6,3.1,1.8,4.2l14,14.1c1.1,1.1,2.7,1.8,4.2,1.8h19.9c1.6,0,3.1-.6,4.2-1.8l14.1-14.1c1.1-1.1,1.8-2.7,1.8-4.2v-19.8c0-1.6-.6-3.1-1.8-4.2L44.2,1.8Zm-14.02,30.51c0,1.1-.81-1.55-1.51-.75l.38,3.29c-.7.8,12.35,3.05,11.25,3.05l-2.41-4.84c-1.1,0-1.09,9.74-1.79,8.94H13.8c-.8-.7,4.4,1.5,4.4.4l8.78,4.96c0-1.1,2.22,1.93,2.92,1.13l13.93-10.82c.7-.8-3.86-18.45-14.4-10.54l6.88-.93c1.1,0-4.7.8-3.9,1.6l2.8,8.4c.8.7,5.1.6,5.1,1.6l-10.12-5.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.82,5.23L6.16,39.15c-1.84,3.24.43,7.35,4.21,7.35h39.21c3.78,0,6.16-4.1,4.21-7.35L34.35,5.23c-1.94-3.35-6.7-3.35-8.53,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m26.61,39.6c0-1.66,1.44-2.86,3.39-2.86,2.07,0,3.39,1.2,3.39,2.86s-1.32,2.86-3.39,2.86-3.39-1.25-3.39-2.86Zm1.44-6.61l-.8-22.17h5.52l-.8,22.17h-3.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendService);
export default __webpack_public_path__ + "static/media/Suspend-Service.9047912b430202f6395c523a19072b45.svg";
export { ForwardRef as ReactComponent };